module.exports = __webpack_public_path__ + "img/user-icon.75856012.jpg";